// extracted by mini-css-extract-plugin
export var category = "styles-module--category--1GpzA";
export var category_text = "styles-module--category_text--3arjM";
export var dark = "styles-module--dark--2tguL";
export var active = "styles-module--active--1MiZo";
export var red = "styles-module--red--6IT2X";